import useTranslation from "utils/hooks/useTranslation";
import { env } from "env";
import { useAppSelector } from "store/hooks";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

interface ProductModalContentProps {
    data?: any
}

const ProductModalContent5: React.FC<ProductModalContentProps> = ({ data }) => {
    const { t } = useTranslation();
    const { network } = useSalesNetwork();
    const projectStore = useAppSelector((state) => state.project);

    const schema = data.product.code_schema + projectStore.project.schemaCode; // NOSONAR

    return (
        <>
            <group
                data-gap="30"
                data-text-size="medium"
                data-space-vertical="30"
                data-space-horizontal="50"
                data-direction="column"
                data-justify="start"
            >

                <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20" data-max-length="1440">
                    <group data-height="50" data-length="5" data-background="main"></group>
                    <group data-length="autofit" data-align="center">
                        <text data-text-size="22" data-weight="600">{t("INSTALL_RECOMMENDATION")}</text>
                    </group>
                </group>

                <text>{t("HYDRAULIC_SCHEME")}</text>
                <group>
                    <picture>
                        <img src={`${env.api_url}/assets/data/schemas/${data.product.code_schema}/${schema}/${schema}.JPG`} width={"100%"} alt="" />
                    </picture>
                </group>
                {network?._parameters?.SYNTH_HYDRAU_IMAGE2 && (
                    <group>
                        <picture>
                            <img src={network._parameters.SYNTH_HYDRAU_IMAGE2} width={"100%"} alt="" />
                        </picture>
                    </group>
                )}
                <text>{t("INSTALL_RECOMMENDATION")}</text>
                {data.product.hydrau_schema && (
                    <group>
                        <picture>
                            <img src={data.product.hydrau_schema} width={"100%"} alt="" />
                        </picture>
                    </group>
                )}

                <text>{t("ELEC_SCHEMA_TITLE")}</text>
                <group>
                    <picture>
                        <img src={data.product.elec_schema} width={"100%"} alt="" />
                    </picture>
                </group>
                {network?._parameters?.SYNTH_ELEC_IMAGE2 && (
                    <group>
                        <picture>
                            <img src={network._parameters.SYNTH_ELEC_IMAGE2} width={"100%"} alt="" />
                        </picture>
                    </group>
                )}
            </group>

        </>
    )
}

export default ProductModalContent5;